import React, { Fragment } from "react";
import { Link } from "@quintype/components";
import { Menu } from "../menu/menu";
import { SocialFollow } from "../../basic/social-follow/social-follow";
import get from "lodash/get";
import PropTypes from "prop-types";
import "./sidebar.module.css";

class SidebarTemplate extends React.Component {
  constructor(props) {
    super(props);
  }

  updateCloseSidebar = e => {
    e.stopPropagation();
    // e.preventDefault();

    return this.props.closeSidebar();
  };

  render() {
    let {
      isSidebarVisible,
      headerConfig,
      menuItems,
      socialLinks,
      languageDirection,
      customCssClasses,
      toggleSidebar,
      closeAll,
      publisherTheme
    } = this.props;
    const enableAccesstype = get(publisherTheme, ["enableAccesstype"]) === "true";
    return (
      <Fragment>
        <div
          styleName={`overlay ${customCssClasses} ${isSidebarVisible ? "overlay--active" : ""} ${
            headerConfig.hamburger === "right" ? "overlay-open-right" : "overlay-open-left"
          }`}
          onClick={this.closeSidebar}
        />
        <div
          styleName={`sidebar sidebar--visible ${customCssClasses} ${
            headerConfig.hamburger === "right" ? "open-right" : "open-left"
          }`}
        >
          <nav>
            <Menu
              closeAll={closeAll}
              styleName="menu"
              menu={menuItems}
              sidebar
              languageDirection={languageDirection}
              toggleSidebar={toggleSidebar}
            />
          </nav>
          <div styleName="cta-wrapper">
            <SocialFollow hasBackground={true} socialLinks={socialLinks} />
            {enableAccesstype && (
              <Link href="/subscription" styleName="btn">
                Subscribe
              </Link>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}
SidebarTemplate.propTypes = {
  headerConfig: PropTypes.object,
  menuItems: PropTypes.object,
  socialLinks: PropTypes.object,
  languageDirection: PropTypes.object,
  customCssClasses: PropTypes.object,
  toggleSidebar: PropTypes.func,
  closeAll: PropTypes.func,
  publisherTheme: PropTypes.object,
  closeSidebar: PropTypes.func,
  isSidebarVisible: PropTypes.func
};

export { SidebarTemplate };
